import Table, { TableProps } from './Table';

export type { TableProps };

export default Table;
